module.exports = __webpack_public_path__ + "static/img/buju1.f7b16953.png";